import React, { memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Locale from '@active/react-utils/i18n/Locale';
import Button from '@active/react-ui/Button';
import isEmpty from 'lodash/isEmpty';
import {
  useRemoveMagazineMutation,
} from '../../../../../store/services/common/offers/offerApi.js';
import pubSubInstance from '../../../../../shared/utils/pubSub.js';
import { useDeepEffect } from '../../../../../shared/utils/customizedHooks';
import { setMagazineDatas } from '../../offerSlice.js';

const SynapseMagazine = () => {
  const dispatch = useDispatch();
  const {
    entities: {
      magazineDatas,
      magazineDatas: {
        offerName,
        offerId,
        description,
      } = {},
    },
  } = useSelector(state => state.offersData);

  const {
    widgetNameSpace,
  } = useSelector(state => state.propsData);

  const [ removeMagazine ] = useRemoveMagazineMutation();

  useDeepEffect(() => {
    if (!isEmpty(magazineDatas)) {
      sessionStorage.setItem(`${widgetNameSpace}-checkoutMagazine`, JSON.stringify(magazineDatas));
    }
  }, [ magazineDatas, widgetNameSpace ]);

  const onRemove = useCallback(() => {
    removeMagazine({
      params: {
        offerId,
      },
    }).unwrap().then((
      { repriceRequired },
    ) => {
      dispatch(setMagazineDatas(undefined));
      sessionStorage.removeItem(`${widgetNameSpace}-checkoutMagazine`);
      if (repriceRequired) {
        pubSubInstance.dispatch(`${widgetNameSpace}-reload`);
      }
    });
  }, [ offerId, widgetNameSpace, dispatch ]);

  if (!offerId) return null;

  return (<div className="checkout-magazine cui-mg-t-60">
    <h2 className="region_title">
      <Locale id="checkout.lib.components.text.magazine"/>
    </h2>
    <div className="magazine cui-mg-t-20">
      <div className='magazine_name' dangerouslySetInnerHTML={{ __html: offerName }}>
      </div>
      <div className='magazine_content'>
        <div className='magazine_description' dangerouslySetInnerHTML={{ __html: description }}>
        </div>
        <Button noSubmit className="magazine_remove-button" onClick={onRemove}>
          <Locale id="checkout.lib.components.common.btn.removeFromCart"/>
        </Button>
      </div>
    </div>
  </div>);
};

export default memo(SynapseMagazine);
